import { CAFFENIO_AUTH_ID, AUTH_REQUEST }  from "../constants";
import * as querystring from 'querystring';

// Llamadas a la API para la autentificación
export default class Auth {
    static login = (username, password) => {
        let data = {
            username: username,
            password: password,
            grant_type: "password",
            client_id: CAFFENIO_AUTH_ID
        };

        return AUTH_REQUEST.post('/login', querystring.stringify(data));
    }
}
